module.exports = require('./helpers/bundle-url').getBundleURL('9U9Lq') + "background-bottom-1.9a9ec083.svg";